import {BoroughDto, boroughsDto} from "homey-housing-lottery-app-dto";

export type Borough = BoroughDto;
export const boroughs = boroughsDto
